import { Injectable, isDevMode } from '@angular/core'
import { BehaviorSubject, map, Observable } from 'rxjs'

const log = (message: string, _meta?: any) => {
  if (isDevMode()) {
    // eslint-disable-next-line no-console
    console.log(`[ProgressService]: ${message}`)
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProgressService<Key extends string | number = string> {
  private inProgress$ = new BehaviorSubject<Set<Key>>(new Set())

  start(key: Key, meta?: any): void {
    const set = this.inProgress$.getValue()
    set.add(key)
    this.inProgress$.next(set)
    log(`started ${key}`, meta)
  }

  stop(key: Key, meta?: any): void {
    const set = this.inProgress$.getValue()
    set.delete(key)
    this.inProgress$.next(set)
    log(`stopped ${key}`, meta)
  }

  /**
   * Observe if there is any step in progress
   */
  progress$ = this.inProgress$.pipe(
    map(set => set.size > 0),
  )

  /**
   * Observe if a specific step is in progress
   */
  inProgress(...keys: Key[]): Observable<boolean> {
    return this.inProgress$.pipe(
      map(set => keys.some(key => set.has(key))),
    )
  }

  constructor() {
    // set up an interval just to help developers monitor/diagnose which tasks are outstanding
    setInterval(() => {
      const keys = [...this.inProgress$.getValue() ?? []]
      if (keys.length > 0) {
        log(`waiting on ${keys.join(', ')}`)
      }
    }, 1000)
  }
}
